import {EditProjectDetailsFormValidationSchema} from '@/features/projects/formSchemas'
import {zodResolver} from '@hookform/resolvers/zod'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

interface EditProjectDetailsFormProviderProps {
    defaultValues: Partial<EditProjectDetailsFormValidationSchema>
    children: ReactNode
}

export const EditProjectDetailsFormProvider = ({defaultValues, children}: EditProjectDetailsFormProviderProps) => {
    const form = useForm<Partial<EditProjectDetailsFormValidationSchema>>({
        mode: 'onBlur',
        resolver: zodResolver(EditProjectDetailsFormValidationSchema),
        defaultValues
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
